import { Grid } from "@mui/material";
import {
  ProductSuggestion,
  RouteLeavingGuard,
  TitleAndActionBox,
} from "../../../common";
import { ImageModal } from "../../../common/Modals";
import ExpandableWrapper from "../../../../Libraries/ExpandWrapper";
import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import {
  AppImageUploader,
  HeadingText,
  ParagraphText,
  UBButton,
  UBInput,
} from "../../../../Libraries";
import { Box, CircularProgress } from "@mui/material";
import { EnterIcon, SuccessIcon } from "../../../../assets/icons/icon";
import { unitKB_2 } from "../../../../constants";
import { Sync } from "../../../../SyncService";
import UBDateSelect from "../../../../Libraries/UBDateSelect";
import { useSnackbar } from "../../../../context/SnackbarContext";
import { LanguageContext } from "../../../../context/LanguageContext";
import { blurAllInputField, ValidateUploadedFile } from "../../../../utils";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useAuthContext } from "../../../../context/AuthContext";
import styles from "../../SaleExpense/SaleExpenseForm/styles.module.css";
import TabAutoComplete from "../../../../Libraries/TabAutoComplete";
import withObservables from "@nozbe/with-observables";
import classes from "./styles.module.css";
import datePickerStyles from "../../../common/Modals/RecordPaymentModal/styles.module.css";
import { analytics, triggerLogEvent } from "../../../../config/firebase";

import { useDemoModeNavigation } from "../../../../hooks/useDemoNavigation";
import moment from "moment";
import { fetchUnArchivedStockCount } from "../../../../database/helpers/stock";

const EditStockItem = ({ customUnit }) => {
  const location = useLocation();
  const [inventoryExpanded, setinventoryExpanded] = useState(false);
  const [wholesaleExpanded, setwholesaleExpanded] = useState(false);
  const [batchExpiryExpanded, setbatchExpiryExpanded] = useState(false);

  const [errors, setErrors] = useState({});
  const [editItem, setEditItem] = useState({});
  const [files, setFiles] = useState([]);
  const [stockItem, setStockItem] = useState({
    itemName: location?.state?.itemName || "",
    quantity: "",
    unit: "",
    secondaryUnit: "",
    conversionValue: "",
    sell: "",
    cost: "",
    lowStock: "",
    barcode: "",
    expiryDate: "",
    expiryAlert: "",
    batchNumber: "",
    wholeSalePrice: "",
    manufacturingDate: "",
    minimumOrderQuantity: "",
    sku: "",
  });
  const [unitList, setUnitList] = useState([]);
  const [isDirty, setDirty] = useState(false);
  const navigate = useNavigate();
  const params = useParams();
  const isEditMode = location.pathname?.toLowerCase()?.includes("edit");
  const { showSnackbar } = useSnackbar();
  const { user, business } = useAuthContext();
  const [I18n] = useContext(LanguageContext);
  const [isLoading, setIsLoading] = useState(false);
  const [isItemDataLoading, setIsItemDataLoading] = useState(isEditMode);
  const [isOpenSuggestion, setIsOpenSuggestion] = useState(false);
  const [imageModal, setImageModal] = useState(false);
  const [errorState, setErrorState] = useState({
    manufactureDate: "",
    expiryDate: "",
    expiryAlertDate: "",
    secondaryUnitError: "",
    primaryUnitError: "",
    conversionValue: "",
  });

  const { id } = params;
  const { handleDemoNavigation } = useDemoModeNavigation();

  const isProfit = Number(stockItem.sell) > Number(stockItem.cost);
  const difference = Math.abs(
    Number(stockItem.sell || 0) - Number(stockItem.cost || 0),
  );
  useEffect(() => {
    const list = customUnit.length
      ? customUnit.map((item) => {
        return {
          label: item.name,
          value: item.name,
        };
      })
      : [];
    setUnitList([...unitKB_2, ...list]);
  }, [customUnit.length]);

  useEffect(() => {
    const fetchStockItemData = async () => {
      if (!isEditMode || !id) {
        setIsItemDataLoading(false);
        return;
      }
      try {
        const stockItemObj = await business.fetchStockById(id);
        const fetchedStockItem = stockItemObj[0];
        if (fetchedStockItem) {
          setEditItem({ ...fetchedStockItem?._raw });
          if (fetchedStockItem.image_url) {
            setFiles([
              {
                name: "item_image",
                file: fetchedStockItem.image_url,
                type: "image/jpeg",
              },
            ]);
          }
          setStockItem({
            itemName: fetchedStockItem.name || "",
            quantity: fetchedStockItem.stock
              ? fetchedStockItem.stock.toString()
              : "",
            unit: fetchedStockItem.unit || "",
            secondaryUnit: fetchedStockItem.secondary_unit || "",
            conversionValue: fetchedStockItem.unit_conversion
              ? fetchedStockItem.unit_conversion.toString()
              : "",
            sell: fetchedStockItem.selling_price
              ? fetchedStockItem.selling_price.toString()
              : "",
            cost: fetchedStockItem.cost_price
              ? fetchedStockItem.cost_price.toString()
              : "",
            lowStock: fetchedStockItem.low_stock
              ? fetchedStockItem.low_stock.toString()
              : "",
            barcode: fetchedStockItem.barcode
              ? fetchedStockItem.barcode.toString()
              : "",
            expiryDate: fetchedStockItem.expiry_date || "",
            expiryAlert: fetchedStockItem.expiry_alert || "",
            batchNumber: fetchedStockItem.batch_number
              ? fetchedStockItem.batch_number.toString()
              : "",
            wholeSalePrice: fetchedStockItem.wholesale_price
              ? fetchedStockItem.wholesale_price.toString()
              : "",
            manufacturingDate: fetchedStockItem.manufacturing_date || "",
            minimumOrderQuantity: fetchedStockItem.minimum_order_quantity
              ? fetchedStockItem.minimum_order_quantity.toString()
              : "",
            sku: fetchedStockItem.sku || "",
          });
        }
      } finally {
        setIsItemDataLoading(false);
      }
    };

    fetchStockItemData();
  }, [isEditMode, business]);

  const handleEditSave = (e) => {
    e?.preventDefault();
    if (isEditMode) {
      handleEdit();
    } else {
      handleSave();
    }
  };

  const scrollToField = useCallback((fieldId) => {
    setTimeout(() => {
      const field = document.getElementById(fieldId);

      if (!field) return;

      field.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });

      const focusableField =
        field.tagName === "INPUT"
          ? field
          : field.querySelector?.("input, textarea, [tabindex]");

      focusableField?.focus?.();
    }, 250);
  }, []);

  const validateFields = () => {
    const newErrors = {};
    if (!stockItem.itemName.trim())
      newErrors.itemName = "Item name is required";
    if (
      stockItem.unit &&
      stockItem.secondaryUnit &&
      !stockItem.conversionValue
    ) {
      newErrors.conversionValue = "Rate is required";
    }

    if (stockItem.secondaryUnit && !stockItem.unit) {
      newErrors.primaryUnitError = I18n.please_select_primary_unit_first;
    }

    setErrors(newErrors);
    if (newErrors.itemName) {
      scrollToField("stock_item_name");
    } else if (newErrors.conversionValue) {
      setinventoryExpanded(true);
      scrollToField("stock_item_conversation_unit");
    } else if (errorState?.expiryDate) {
      scrollToField("stock_expiry_date");
    } else if (errorState?.manufactureDate) {
      scrollToField("stock_manufacturing_date");
    }
    return Object.keys(newErrors).length === 0 && !errorState?.expiryDate && !errorState?.manufactureDate;
  };

  const handleSave = async () => {
    if (!validateFields()) return;
    if (
      stockItem.secondaryUnit &&
      stockItem.unit &&
      stockItem.conversionValue == 0
    ) {
      showSnackbar({
        message: I18n.unit_conversion_error,
        severity: "error",
        toastId: "unit_conversion_error",
      });
      return;
    }

    try {
      setIsLoading(true);
      const paramsForStock = {
        name: stockItem.itemName,
        stock: Number(stockItem.quantity || 0),
        cost_price: Number(stockItem.cost || 0),
        selling_price: Number(stockItem.sell || 0),
        unit: stockItem.unit || "Pieces",
        secondary_unit: errorState?.secondaryUnitError
          ? ""
          : stockItem.secondaryUnit,
        unit_conversion: stockItem.conversionValue
          ? Number(stockItem.conversionValue)
          : null,
        imei: null,
        batch_number: stockItem.batchNumber
          ? Number(stockItem.batchNumber)
          : null,
        barcode: stockItem.barcode ? Number(stockItem.barcode) : null,
        wholesale_price: stockItem.wholeSalePrice
          ? Number(stockItem.wholeSalePrice)
          : null,
        expiry_date: errorState.expiryDate ? null : stockItem.expiryDate,
        manufacturing_date: errorState.manufactureDate
          ? null
          : stockItem.manufacturingDate,
        low_stock: stockItem.lowStock ? Number(stockItem.lowStock) : null,
        image_url: files[0]?.file || null,
        sku: stockItem.sku || null,
        expiry_alert: errorState.expiryAlertDate
          ? null
          : stockItem.expiryAlert
            ? Number(stockItem.expiryAlert)
            : null,
        minimum_order_quantity: stockItem.minimumOrderQuantity
          ? Number(stockItem.minimumOrderQuantity)
          : 0,
      };

      let created_stock = await business.createStock(paramsForStock);

      if (paramsForStock.stock) {
        let paramsForInv = {
          unit_conversion: created_stock.unit_conversion,
          transacted_at: created_stock.created_at,
          price: paramsForStock.cost_price,
          quantity: paramsForStock.stock,
          stock: paramsForStock.stock,
          name: paramsForStock.name,
          is_secondary_unit: false,
          type: "in",
        };

        await created_stock.createInventory(paramsForInv);
      }

      if (paramsForStock.image_url)
        triggerLogEvent(analytics, "sb_item_image", {
          imageUrl: paramsForStock.image_url,
        });
      if (paramsForStock.stock)
        triggerLogEvent(analytics, "sb_item_quantity", {
          quantity: paramsForStock.stock,
        });
      if (paramsForStock?.unit)
        triggerLogEvent(analytics, "sb_item_unit", {
          unit: paramsForStock.unit,
        });
      if (paramsForStock?.secondary_unit)
        triggerLogEvent(analytics, "sb_item_second_unit", {
          secondaryUnit: paramsForStock.secondary_unit,
        });
      if (paramsForStock.selling_price)
        triggerLogEvent(analytics, "sb_item_selling_price", {
          sellPrice: paramsForStock.selling_price,
        });
      if (paramsForStock.cost_price)
        triggerLogEvent(analytics, "sb_item_cost_price", {
          costPrice: paramsForStock.cost_price,
        });

      if (paramsForStock.low_stock)
        triggerLogEvent(analytics, "sb_item_low", {
          lowStock: paramsForStock.low_stock,
        });
      if (paramsForStock.barcode)
        triggerLogEvent(analytics, "sb_item_barcode", {
          lowStock: paramsForStock.barcode,
        });
      if (paramsForStock.batch_number)
        triggerLogEvent(analytics, "sb_item_batch", {
          batchNumber: paramsForStock.batch_number,
        });
      if (paramsForStock.expiry_date)
        triggerLogEvent(analytics, "sb_item_expiry_date", {
          batchNumber: paramsForStock.expiry_date,
        });
      if (paramsForStock.expiry_alert)
        triggerLogEvent(analytics, "sb_item_expiry_alert", {
          batchNumber: paramsForStock.expiry_alert,
        });
      if (paramsForStock.wholesale_price)
        triggerLogEvent(analytics, "sb_item_ws_price", {
          batchNumber: paramsForStock.wholesale_price,
        });
      if (paramsForStock.minimum_order_quantity)
        triggerLogEvent(analytics, "sb_item_min_order", {
          minimumOrderQuantity: paramsForStock.minimum_order_quantity,
        });
      if (paramsForStock.manufacturing_date)
        triggerLogEvent(analytics, "sb_item_manufac_date", {
          manufacturingDate: paramsForStock.manufacturing_date,
        });
      const stockByBussiness = await fetchUnArchivedStockCount();
      if (stockByBussiness === 5) {
        triggerLogEvent(analytics, "sb_PU");
      }
      setDirty(false);
      await new Promise((r) => setTimeout(r, 0)); // ensure state flush
      handleDemoNavigation(
        "stock",
        location?.state?.pathname || `/Inventory`,
        {},
        1000,
      );

      Sync(user.phone_number, navigate);
      showSnackbar({
        message: "Stock Item Created",
        severity: "success",
      });
      triggerLogEvent(analytics, "sb_item_created", { paramsForStock });
    } catch (err) {
      showSnackbar({
        message: err?.message || "An error occurred",
        severity: "error",
      });
      setIsLoading(false);
    }
  };

  const handleEdit = async () => {
    if (!validateFields()) return;

    const paramsForStock = {
      name: stockItem.itemName,
      stock: Number(stockItem.quantity || 0),
      cost_price: Number(stockItem.cost || 0),
      selling_price: Number(stockItem.sell || 0),
      unit: stockItem.unit || "Pieces",
      secondary_unit: errorState?.secondaryUnitError
        ? ""
        : stockItem.secondaryUnit,
      unit_conversion: stockItem.conversionValue
        ? Number(stockItem.conversionValue)
        : null,
      imei: null,
      batch_number: stockItem.batchNumber
        ? Number(stockItem.batchNumber)
        : null,
      barcode: stockItem.barcode ? Number(stockItem.barcode) : null,
      wholesale_price: stockItem.wholeSalePrice
        ? Number(stockItem.wholeSalePrice)
        : null,
      expiry_date: errorState.expiryDate ? null : stockItem.expiryDate,
      manufacturing_date: errorState.manufactureDate
        ? null
        : stockItem.manufacturingDate,
      low_stock: stockItem.lowStock ? Number(stockItem.lowStock) : null,
      image_url: files[0]?.file || null,
      sku: stockItem.sku || null,
      expiry_alert: errorState.expiryAlertDate ? null : stockItem.expiryAlert,
      minimum_order_quantity: stockItem.minimumOrderQuantity
        ? Number(stockItem.minimumOrderQuantity)
        : 0,
    };

    const stockItemObj = await business.fetchStockById(id);
    const fetched_stock = stockItemObj[0];

    if (fetched_stock.stock != paramsForStock.stock) {
      let paramsForInv = {
        unit_conversion: paramsForStock.unit_conversion,
        transacted_at: new Date().getTime(),
        price: paramsForStock.cost_price,
        quantity: paramsForStock.stock,
        stock: paramsForStock.stock,
        name: paramsForStock.name,
        is_secondary_unit: false,
        type: "in",
      };

      let diff = fetched_stock.stock - paramsForStock.stock;

      if (diff < 0) {
        paramsForInv["price"] = paramsForStock.cost_price;
      } else {
        paramsForInv["type"] = "out";
        paramsForInv["price"] = paramsForStock.selling_price;
      }

      paramsForInv["quantity"] = Math.abs(diff);

      await fetched_stock.createInventory(paramsForInv);
    }

    await fetched_stock.updateItem(paramsForStock);
    setDirty(false);
    Sync(user.phone_number, navigate);

    showSnackbar({
      message: "Changes saved successfully",
      severity: "success",
    });
    if (paramsForStock.name != editItem.name)
      triggerLogEvent(analytics, "sb_edit_name", {
        imageUrl: paramsForStock.image_url,
      });
    if (paramsForStock.image_url != editItem.image_url)
      triggerLogEvent(analytics, "sb_edit_image", {
        imageUrl: paramsForStock.image_url,
      });
    if (paramsForStock.stock != editItem.stock)
      triggerLogEvent(analytics, "sb_edit_quantity", {
        quantity: paramsForStock.stock,
      });
    if (paramsForStock.selling_price != editItem.selling_price)
      triggerLogEvent(analytics, "sb_edit_selling_price", {
        sellPrice: paramsForStock.selling_price,
      });
    if (paramsForStock.cost_price != editItem.cost_price)
      triggerLogEvent(analytics, "sb_edit_cost_price", {
        costPrice: paramsForStock.cost_price,
      });

    if (paramsForStock.low_stock != editItem.low_stock)
      triggerLogEvent(analytics, "sb_edit_low", {
        lowStock: paramsForStock.low_stock,
      });
    if (paramsForStock.barcode != editItem.barcode)
      triggerLogEvent(analytics, "sb_edit_barcode", {
        lowStock: paramsForStock.barcode,
      });
    if (paramsForStock.batch_number != editItem.batch_number)
      triggerLogEvent(analytics, "sb_edit_batch", {
        batchNumber: paramsForStock.batch_number,
      });
    if (
      (paramsForStock.expiry_date || editItem.expiry_date) &&
      !moment(paramsForStock.expiry_date).isSame(moment(editItem.expiry_date))
    )
      triggerLogEvent(analytics, "sb_edit_expiry_date", {
        batchNumber: paramsForStock.expiry_date,
      });
    if (
      (paramsForStock.expiry_alert || editItem.expiry_alert) &&
      !moment(paramsForStock.expiry_alert).isSame(moment(editItem.expiry_alert))
    )
      triggerLogEvent(analytics, "sb_edit_expiry_alert", {
        batchNumber: paramsForStock.expiry_alert,
      });
    if (paramsForStock.wholesale_price != editItem.wholesale_price)
      triggerLogEvent(analytics, "sb_edit_ws_price", {
        batchNumber: paramsForStock.wholesale_price,
      });
    if (
      paramsForStock.minimum_order_quantity != editItem.minimum_order_quantity
    )
      triggerLogEvent(analytics, "sb_edit_min_order", {
        minimumOrderQuantity: paramsForStock.minimum_order_quantity,
      });
    if (
      (paramsForStock.manufacturing_date || editItem.manufacturing_date) &&
      !moment(paramsForStock.manufacturing_date).isSame(
        moment(editItem.manufacturing_date),
      )
    )
      triggerLogEvent(analytics, "sb_edit_manufac_date", {
        manufacturingDate: paramsForStock.manufacturing_date,
      });

    triggerLogEvent(analytics, "sb_editted", { paramsForStock });

    setTimeout(() => {
      navigate(location?.state?.pathname || "/Inventory", { replace: true });
    }, 200);
  };

  const handleUnitSelect = useCallback(
    (value) => {
      setStockItem((prevState) => ({
        ...prevState,
        unit: value,
      }));
      setDirty(true);
    },
    [stockItem.unit],
  );

  const handleSecondaryUnitSelect = useCallback(
    (value) => {
      setStockItem((prevState) => ({
        ...prevState,
        secondaryUnit: value,
      }));
      setDirty(true);
    },
    [stockItem.secondaryUnit],
  );

  const handleCreateUnit = async (val, key) => {
    const isExist = unitList.find(
      (item) => item.label.toLocaleLowerCase() === val.toLocaleLowerCase(),
    );
    setStockItem((prevState) => ({
      ...prevState,
      [key]: val,
    }));
    if (isExist) return;
    await business.createUnit(val);
    setUnitList([...unitList, { label: val, value: val }]);
  };

  const handleSetError = (errors) =>
    setErrorState((e) => ({ ...e, ...errors }));

  const isDisabled = useMemo(() => {
    if (
      !isLoading &&
      !isItemDataLoading &&
      stockItem.itemName &&
      !isOpenSuggestion
    ) {
      return false;
    }
    return true;
  }, [isLoading, isItemDataLoading, stockItem.itemName, isOpenSuggestion]);

  const toggleImageModal = (toggle = false) => setImageModal(toggle);

  const handleImage = (_title, value, file) => {
    if (file) {
      const valid = ValidateUploadedFile({
        file,
        I18n,
        allowedTypes: ["image/jpeg", "image/png", "image/jpg"],
      });
      if (!valid.valid) {
        showSnackbar({
          message: valid.message || I18n.unsupported_file_format,
          severity: "error",
        });
        return;
      }
    }
    if (!isEditMode) triggerLogEvent(analytics, "sb_item_photo_start");
    setDirty(true);
    setFiles([
      {
        name: file?.name || "item_image",
        file: value,
        type: file?.type || "image/jpeg",
      },
    ]);
  };

  const handleDeleteImage = () => {
    setFiles([]);
    setDirty(true);
    toggleImageModal();
  };

  const handleReupload = () => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = "image/*";
    input.onchange = (event) => {
      const file = event.target.files[0];
      if (!file) return;
      const valid = ValidateUploadedFile({
        file,
        I18n,
        allowedTypes: ["image/jpeg", "image/png", "image/jpg"],
      });
      if (!valid.valid) {
        showSnackbar({
          message: valid.message || I18n.unsupported_file_format,
          severity: "error",
        });
        return;
      }
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => handleImage(I18n.upload_photo, reader.result, file);
    };
    input.click();
  };

  return (
    <Grid
      container
      className={`${styles.root} ${styles.SaleExpenseFormWrapper} EditStockItem`}
    >
      <Grid item md={12}>
        <TitleAndActionBox
          data={{
            title: isEditMode ? "edit_item" : "create_item",
            isBack: true,
            onBack: () => navigate(-1),
            id: "stock",
          }}
        />

        <Box className={styles.formBodyGrid}>
          <Box className={styles.formColumn}>
            <Box
              className={`${styles.formBody} expenseFormBody editStockFormBody`}
              onKeyDown={(e) => {
                if (e.key === "Enter" && e.shiftKey) {
                  e.preventDefault();
                  if (!isDisabled) {
                    blurAllInputField();
                    handleEditSave();
                  }
                }
              }}
            >
              <HeadingText as="h1" className={classes.addHeading}>
                Item detail
              </HeadingText>

              <Box className={classes.stockImageWrapper}>
                <AppImageUploader
                  toggleImageModal={() => toggleImageModal(true)}
                  image={files[0]?.file || ""}
                  handleImage={handleImage}
                  title={I18n.upload_photo}
                  id="stock_item_image"
                  I18n={I18n}
                />
              </Box>

              <ProductSuggestion
                placeholder={I18n.item_name}
                name={stockItem.itemName}
                required={true}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    e.preventDefault();
                    if (!isDisabled) handleEditSave();
                  }
                }}
                setName={(value) => {
                  if (stockItem?.itemName?.length == 0 && value?.length >= 1)
                    triggerLogEvent(analytics, "sb_item_name_start");
                  setStockItem((prevState) => ({
                    ...prevState,
                    itemName: value,
                  }));
                  setDirty(true);
                  setErrors((prevErrors) => ({
                    ...prevErrors,
                    itemName: "",
                  }));
                }}
                label={I18n.item_name}
                maxLength={100}
                handleSetProduct={(item) => {
                  setStockItem((prevState) => ({
                    ...prevState,
                    itemName: item.product_name,
                    quantity: 1,
                    sell: item.price,
                  }));
                }}
                toogleProductionSuggestion={(bool) => setIsOpenSuggestion(bool)}
                error={{ text: errors.itemName, show: !!errors.itemName }}
                autoFocus={true}
                inputId="stock_item_name"
              />
              <Box className={classes.costAndSalesWrapper}>
                <UBInput
                  inputId="stock_cost_rs"
                  placeholder={I18n.cost_price}
                  baseClassname={classes.stockInputs}
                  label={I18n.cost_price}
                  value={stockItem.cost}
                  maxLength={7}
                  error={false}
                  onChange={(e, value) => {
                    const inputValue = value;
                    if (/^\d*$/.test(inputValue)) {
                      if (
                        stockItem?.cost?.length == 0 &&
                        inputValue?.length >= 1
                      )
                        triggerLogEvent(analytics, "sb_item_cost_start");
                      setStockItem((prevState) => ({
                        ...prevState,
                        cost: inputValue,
                      }));
                      setDirty(true);
                      setErrors((prevErrors) => ({
                        ...prevErrors,
                        cost: "",
                      }));
                    }
                  }}
                />

                <UBInput
                  inputId="stock_sell_rs"
                  placeholder={I18n.sell_price}
                  baseClassname={classes.stockInputs}
                  className={classes.sellInput}
                  label={I18n.sell_price}
                  value={stockItem.sell}
                  maxLength={7}
                  error={false}
                  onChange={(e, value) => {
                    const inputValue = value;
                    if (/^\d*$/.test(inputValue)) {
                      if (
                        stockItem?.sell?.length == 0 &&
                        inputValue?.length >= 1
                      )
                        triggerLogEvent(analytics, "sb_item_sell_start");
                      setStockItem((prevState) => ({
                        ...prevState,
                        sell: inputValue,
                      }));
                      setDirty(true);
                      setErrors((prevErrors) => ({
                        ...prevErrors,
                        sell: "",
                      }));
                    }
                  }}
                  infoLabel={
                    <Box display={"flex"} alignItems={"center"}>
                      {`${
                        isProfit
                          ? "PROFIT"
                          : difference === 0
                            ? "Profit"
                            : "Loss"
                      } Rs. ${difference.toLocaleString()}`}
                    </Box>
                  }
                />
              </Box>

              <ExpandableWrapper
                title={I18n.inventory}
                className={"additionalDetailsWrapper inventoryDetailsWrapper"}
                expanded={inventoryExpanded}
                setExpanded={setinventoryExpanded}
                id="additional_details"
              >
                <Box
                  className={`${classes.costAndSalesWrapper} ${classes.costAndSalesInputsWrapper}`}
                >
                  <UBInput
                    inputId="stock_barcode_number"
                    placeholder={I18n.barcode_number}
                    baseClassname={classes.stockInputs}
                    label={I18n.barcode_number}
                    value={stockItem.barcode}
                    maxLength={30}
                    onChange={(e, value) => {
                      const inputValue = value;
                      if (/^\d*$/.test(inputValue)) {
                        if (
                          stockItem?.barcode?.length == 0 &&
                          inputValue?.length >= 1
                        )
                          triggerLogEvent(analytics, "sb_item_bar_start");
                        setStockItem((prevState) => ({
                          ...prevState,
                          barcode: inputValue,
                        }));
                        setDirty(true);
                      }
                    }}
                  />

                  <UBInput
                    inputId="stock_sku"
                    placeholder={I18n.sku}
                    baseClassname={classes.stockInputs}
                    label={<span className="textUppercase">{I18n.sku}</span>}
                    value={stockItem.sku}
                    onChange={(e, value) => {
                      const inputValue = value;
                      if (
                        stockItem?.sku?.length == 0 &&
                        inputValue?.length >= 1
                      )
                        triggerLogEvent(analytics, "sb_item_sju_start");
                      setStockItem((prevState) => ({
                        ...prevState,
                        sku: inputValue,
                      }));
                      setDirty(true);
                    }}
                  />
                </Box>

                <Box
                  className={`${classes.costAndSalesWrapper} ${classes.costAndSalesInputsWrapper}`}
                >
                  <TabAutoComplete
                    id="stock_item_unit"
                    list={unitList}
                    label={I18n.primary_unit}
                    handleSelect={(item) => {
                      if (!item) {
                        handleUnitSelect("");
                        handleSecondaryUnitSelect("");
                        return;
                      }
                      if (item?.value === stockItem.secondaryUnit) {
                        showSnackbar({
                          message:
                            I18n.primary_unit_cannot_be_same_to_secondary_unit,
                          severity: "error",
                          toastId: "primaryUnitError",
                        });
                        handleUnitSelect("");
                        return;
                      }
                      handleUnitSelect(item?.value || "");
                      setStockItem((prevState) => ({
                        ...prevState,
                        conversionValue: "",
                      }));
                    }}
                    value={stockItem.unit}
                    handleCreate={(val) => handleCreateUnit(val, "unit")}
                    asCreate="unit"
                    requireSearchToCreate
                    placeholder={I18n.primary_unit}
                    handleStartLogEvent={() =>
                      triggerLogEvent(analytics, "sb_item_pri_unit_start")
                    }
                    disabled={isEditMode}
                  />

                  <TabAutoComplete
                    id="stock_secondary_unit"
                    list={unitList}
                    label={I18n.secondary_unit}
                    handleSelect={(item) => {
                      if (!item) {
                        handleSecondaryUnitSelect("");
                        return;
                      }
                      if (item?.value === stockItem.unit) {
                        showSnackbar({
                          message:
                            I18n.secondary_unit_cannot_be_same_to_primary_unit,
                          severity: "error",
                          toastId: "secondaryUnitError",
                        });
                        handleSecondaryUnitSelect("");
                        return;
                      }
                      handleSecondaryUnitSelect(item?.value || "");
                      setStockItem((prevState) => ({
                        ...prevState,
                        conversionValue: "",
                      }));
                    }}
                    value={stockItem.secondaryUnit}
                    handleCreate={(val) =>
                      handleCreateUnit(val, "secondaryUnit")
                    }
                    asCreate="secondary unit"
                    requireSearchToCreate
                    placeholder={I18n.secondary_unit}
                    handleStartLogEvent={() =>
                      triggerLogEvent(analytics, "sb_item_sec_unit_start")
                    }
                    onFocus={() => {
                      if (!stockItem.unit) {
                        handleSetError({
                          primaryUnitError:
                            I18n.please_select_primary_unit_first,
                        });
                      }
                    }}
                    disabled={isEditMode || !stockItem?.unit}
                  />
                </Box>

                {stockItem.unit &&
                  stockItem.secondaryUnit &&
                  !errorState?.secondaryUnitError && (
                    <span
                      className={`${classes.conversionRate} conversionRate`}
                    >
                      Conversion rate:&nbsp; {"1"} {stockItem.unit} =
                      <span
                        className={`foundationRedNormalColor ${classes.unitConversation}`}
                      >
                        *
                      </span>{" "}
                      &nbsp;
                      <UBInput
                        inputId="stock_item_conversation_unit"
                        inputClassname={classes.conversionRateInput}
                        value={stockItem.conversionValue}
                        tabIndex={0}
                        maxLength={8}
                        onChange={(e, value) => {
                          const inputValue = value;
                          if (/^\d*$/.test(inputValue)) {
                            setStockItem((prevState) => ({
                              ...prevState,
                              conversionValue: inputValue,
                            }));
                            setDirty(true);
                          }

                          if (errors.conversionValue) {
                            setErrors({
                              ...errors,
                              conversionValue: "",
                            });
                          }
                        }}
                        placeholder={"0"}
                        disabled={isEditMode}
                        error={{
                          text: errors.conversionValue,
                          show: !!errors.conversionValue,
                        }}
                      />{" "}
                      &nbsp;{stockItem.secondaryUnit}
                    </span>
                  )}

                <Box
                  className={`${classes.costAndSalesWrapper} ${classes.costAndSalesInputsWrapper}`}
                >
                  <UBInput
                    inputId="stock_item_qty"
                    placeholder={I18n.stock_quantity}
                    baseClassname={classes.stockInputs}
                    label={I18n.stock_quantity}
                    value={stockItem.quantity}
                    maxLength={7}
                    onChange={(e, value) => {
                      const inputValue = value;
                      if (/^\d*$/.test(inputValue)) {
                        if (
                          stockItem?.quantity?.length == 0 &&
                          inputValue?.length >= 1
                        )
                          triggerLogEvent(analytics, "sb_item_qty_start");
                        setStockItem((prevState) => ({
                          ...prevState,
                          quantity: inputValue,
                        }));
                        setDirty(true);
                        setErrors((prevErrors) => ({
                          ...prevErrors,
                          quantity: "",
                        }));
                      }
                    }}
                  />

                  <UBInput
                    inputId="stock_low_stock_alert"
                    placeholder={I18n.low_stock_alert}
                    baseClassname={classes.stockInputs}
                    label={I18n.low_stock_alert}
                    value={stockItem.lowStock}
                    maxLength={7}
                    onChange={(e, value) => {
                      const inputValue = value;
                      if (/^\d*$/.test(inputValue)) {
                        if (
                          stockItem?.lowStock?.length == 0 &&
                          inputValue?.length >= 1
                        )
                          triggerLogEvent(analytics, "sb_item_low_start");
                        setStockItem((prevState) => ({
                          ...prevState,
                          lowStock: inputValue,
                        }));
                        setDirty(true);
                        setErrors((prevErrors) => ({
                          ...prevErrors,
                          lowStock: "",
                        }));
                      }
                    }}
                  />
                </Box>
              </ExpandableWrapper>
              <ExpandableWrapper
                title={I18n.wholesale}
                className={"additionalDetailsWrapper inventoryDetailsWrapper"}
                expanded={wholesaleExpanded}
                setExpanded={setwholesaleExpanded}
                id="wholesale_details"
              >
                <Box
                  className={`${classes.costAndSalesWrapper} ${classes.costAndSalesInputsWrapper}`}
                >
                  <UBInput
                    inputId="stock_wholesalePrice"
                    placeholder={I18n.wholesale_price}
                    baseClassname={classes.stockInputs}
                    label={I18n.wholesale_price}
                    value={stockItem.wholeSalePrice}
                    maxLength={7}
                    onChange={(e, value) => {
                      const inputValue = value;
                      if (/^\d*$/.test(inputValue)) {
                        if (
                          stockItem?.wholeSalePrice?.length == 0 &&
                          inputValue?.length >= 1
                        )
                          triggerLogEvent(analytics, "sb_item_ws_start");
                        setStockItem((prevState) => ({
                          ...prevState,
                          wholeSalePrice: inputValue,
                        }));
                        setDirty(true);
                      }
                    }}
                  />
                  <UBInput
                    inputId="stock_minimum_order_quantity"
                    placeholder={I18n.minimum_order_quantity}
                    baseClassname={classes.stockInputs}
                    label={I18n.minimum_order_quantity}
                    value={stockItem.minimumOrderQuantity}
                    maxLength={7}
                    onChange={(e, value) => {
                      const inputValue = value;
                      if (/^\d*$/.test(inputValue)) {
                        if (
                          stockItem?.minimumOrderQuantity?.length == 0 &&
                          inputValue?.length >= 1
                        )
                          triggerLogEvent(analytics, "sb_item_min_start");
                        setStockItem((prevState) => ({
                          ...prevState,
                          minimumOrderQuantity: inputValue,
                        }));
                        setDirty(true);
                      }
                    }}
                  />
                </Box>
              </ExpandableWrapper>
              <ExpandableWrapper
                title={I18n.batchAndExpiry}
                className={
                  "additionalDetailsWrapper inventoryDetailsWrapper batchExpiryWrapper"
                }
                expanded={batchExpiryExpanded}
                setExpanded={setbatchExpiryExpanded}
                id="wholesale_details"
              >
                <Box
                  className={`expiryDateWrapper ${classes.costAndSalesWrapper} ${classes.costAndSalesInputsWrapper}`}
                >
                  <UBInput
                    inputId="stock_batch_number"
                    placeholder={I18n.batch_number}
                    baseClassname={classes.stockInputs}
                    label={I18n.batch_number}
                    value={stockItem.batchNumber}
                    onChange={(e, value) => {
                      const inputValue = value;
                      if (/^\d*$/.test(inputValue)) {
                        if (
                          stockItem?.batchNumber?.length == 0 &&
                          inputValue?.length >= 1
                        )
                          triggerLogEvent(analytics, "sb_item_batch_start");
                        setStockItem((prevState) => ({
                          ...prevState,
                          batchNumber: inputValue,
                        }));
                        setDirty(true);
                      }
                    }}
                  />

                  <Box
                    className={`${classes.datePickerWrapper} ${datePickerStyles.markAsPaidDateBoxWrapper}`}
                  >
                    <ParagraphText className="fontSize14 fontWeight400 newFontColor">
                      {I18n.manufacturing_date}
                    </ParagraphText>
                    <UBDateSelect
                      id="stock_manufacturing_date"
                      className="dateSelectWrapper"
                      placeholder={I18n.manufacturing_date}
                      isModal={false}
                      selectedDate={stockItem.manufacturingDate}
                      setSelectedDate={(value) => {
                        if (
                          stockItem.expiryDate &&
                          value &&
                          value.isAfter(stockItem.expiryDate)
                        ) {
                          handleSetError({
                            manufactureDate:
                              I18n.manufactor_lower_expiry_validation_msg,
                          });
                          return;
                        }
                        handleSetError({
                          manufactureDate: "",
                          expiryDate: "",
                        });
                        setStockItem((prevState) => ({
                          ...prevState,
                          manufacturingDate: value,
                        }));
                        setDirty(true);
                      }}
                      title={null}
                      isCalendericon
                      handleLogEvent={() =>
                        triggerLogEvent(analytics, "sb_item_manu_date_start")
                      }
                      error={errorState?.manufactureDate}
                    />
                  </Box>
                </Box>

                <Box
                  className={`expiryDateWrapper ${classes.costAndSalesWrapper}`}
                >
                  <Box
                    className={`${classes.datePickerWrapper} ${datePickerStyles.markAsPaidDateBoxWrapper}`}
                  >
                    <ParagraphText className="fontSize14 fontWeight400 newFontColor">
                      {I18n.expiry_date}
                    </ParagraphText>
                    <UBDateSelect
                      id="stock_expiry_date"
                      className="dateSelectWrapper"
                      placeholder={I18n.expiry_date}
                      isModal={false}
                      selectedDate={stockItem.expiryDate}
                      setSelectedDate={(value) => {
                        if (
                          stockItem.manufacturingDate &&
                          value &&
                          value.isBefore(stockItem.manufacturingDate)
                        ) {
                          handleSetError({
                            expiryDate:
                              I18n.expiry_greater_manufactor_validation_msg,
                          });
                          return;
                        }
                        handleSetError({
                          expiryDate: "",
                          manufactureDate: "",
                          expiryAlertDate: "",
                        });
                        setStockItem((prevState) => ({
                          ...prevState,
                          expiryDate: value,
                          expiryAlert: "",
                        }));
                        setDirty(true);
                      }}
                      title={null}
                      isCalendericon
                      handleLogEvent={() =>
                        triggerLogEvent(analytics, "sb_item_exp_date_start")
                      }
                      error={errorState?.expiryDate}
                    />
                  </Box>

                  <Box
                    className={`${classes.datePickerWrapper} ${datePickerStyles.markAsPaidDateBoxWrapper}`}
                  >
                    <ParagraphText className="fontSize14 fontWeight400 newFontColor">
                      {I18n.expiry_alert}
                    </ParagraphText>
                    <UBDateSelect
                      id="stock_expiry_alert"
                      className="dateSelectWrapper"
                      placeholder={I18n.expiry_alert}
                      isModal={false}
                      selectedDate={stockItem.expiryAlert}
                      error={errorState?.expiryAlertDate}
                      disabled={!stockItem.expiryDate}
                      onClick={() =>
                        showSnackbar({
                          message: "Expiry date is required",
                          severity: "error",
                        })
                      }
                      setSelectedDate={(value) => {
                        if (!stockItem.expiryDate) {
                          handleSetError({
                            expiryAlertDate:
                              "Expiry date is required to set expiry alert.",
                          });
                          return;
                        } else if (
                          stockItem.expiryDate &&
                          value &&
                          value.isAfter(stockItem.expiryDate)
                        ) {
                          handleSetError({
                            expiryAlertDate:
                              I18n.expiry_alert_lower_expiry_validation_msg,
                          });
                          return;
                        } else {
                          handleSetError({ expiryAlertDate: "" });
                        }
                        setStockItem((prevState) => ({
                          ...prevState,
                          expiryAlert: value,
                        }));
                        setDirty(true);
                      }}
                      title={null}
                      isCalendericon
                      handleLogEvent={() =>
                        triggerLogEvent(analytics, "sb_item_exp_alrt_start")
                      }
                    />
                  </Box>
                </Box>
              </ExpandableWrapper>

              <UBButton
                id="stock_save_btn"
                title={<ParagraphText>{I18n.save}</ParagraphText>}
                loading={isLoading}
                iconComponent={<EnterIcon />}
                iconPlacement="right"
                disabled={isLoading || isItemDataLoading}
                className={"buttonPrimary saveSaleButton"}
                onClick={handleEditSave}
              />
            </Box>
          </Box>
        </Box>
      </Grid>
      <ImageModal
        header={{ title: "item_image" }}
        body={{
          title: I18n.upload_or_create_stock,
          image: files[0]?.file || "",
          toggle: imageModal,
          toggleImageModal,
        }}
        footer={[
          {
            data: {
              onClick: handleDeleteImage,
              title: I18n.delete,
              className: "ubSecondaryButton",
            },
          },
          {
            data: {
              className: "ubPrimaryButton",
              title: I18n.change_image,
              onClick: handleReupload,
              id: "stock_item_image_upload_btn",
            },
          },
        ]}
      />
      <RouteLeavingGuard
        when={isDirty}
        confirmText={I18n.discard_stock}
        title={I18n.unsaved_changes}
        message={I18n.are_you_sure_you_want_to_leave_this_screen}
      />
    </Grid>
  );
};

const enhance = withObservables(["business"], ({ business }) => ({
  customUnit: business.unit.observe(),
}));

export default enhance(EditStockItem);
